import {Button, Modal} from "react-bootstrap";
import PropTypes from "prop-types";
import {useUsunRaport} from "../../../../api/domain/raporty/mutations/useUsunRaport.jsx";

export const ModalDeleteRaport = ({currPozycja, show, handleClose, prefix = 'oper'}) => {

    const usunRaport = useUsunRaport(prefix)

    return <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
            <Modal.Title>Usuwanie raportu</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            Czy na pewno chcesz usunąć raport {currPozycja?.id}?
            Po usunięciu raportu nie będzie możliwości jego przywrócenia.
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
                Anuluj
            </Button>
            <Button variant="danger" onClick={() => {
                handleClose();
                usunRaport.mutate(currPozycja.id)
            }}>
                Usuń
            </Button>
        </Modal.Footer>
    </Modal>
}


export const ModalGenerujRaport = ({show, handleClose, id, handleAction, paramsForm}) => {
    return <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
            <Modal.Title>Generowanie raportu</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            Czy na pewno chcesz wygenerować raport {id}?
            Po wygenerowaniu raportu nie będzie możliwości jego edycji.

            <>
            {paramsForm}
            </>

        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
                Anuluj
            </Button>
            <Button variant="success"
                    onClick={() => {
                        handleAction()
                        handleClose();
                    }}>
                Generuj
            </Button>
        </Modal.Footer>
    </Modal>
}

ModalDeleteRaport.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    prefix: PropTypes.string
}